import React from "react";
import DownloadCTA from "../components/home/download";
import Footer from "../components/footer";
import Contact from "../components/contact/contact";
import HeaderAny from "../components/header";
import MobileNav from "../components/header-mobile";

const ContactUs = () => {
    return (
        <div>
            <div>
                <div className="web-only">
                    <HeaderAny />
                </div>
                <div className="mobile-only">
                    <MobileNav />
                </div>
            </div>
            <Contact />
            {/* <div className="cta-padded">
                <DownloadCTA />
            </div> */}
            <Footer />
        </div>
    );
};

export default ContactUs;
